import { render, staticRenderFns } from "./CompanyLegalRegulations.vue?vue&type=template&id=6381d76f&"
import script from "./CompanyLegalRegulations.vue?vue&type=script&lang=js&"
export * from "./CompanyLegalRegulations.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLegalRegulations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports